import { gotoUrl } from "@menu/core/lib";
import MenuContext from "@menu/core/menu.context";
import { defaultLanguage } from "../constants";
import { AuthService } from "./auth.service.interface";

const getCurrentUrl = (withHash = false) => {
    const { origin, pathname, hash } = window.location;
    const parts = [
        origin,
        pathname,
        withHash ? hash : ""
    ];
    return parts.join("");
}

const addRedirectUrl = (value = "", redirectUrl = "") => {
    return value.replace("{redirectUrl}", encodeURI(redirectUrl));
}

const addLanguageCode = (value = "", culture: string) => {
    return value.replace("{language}", culture);
}

const addReturnUrl = (value = "", returnUrl = "") => {
    return value.replace("{returnUrl}", returnUrl);
}

/*
This class no longer uses the Akamai CIAM authentication. It just directs the user to the login 
page set in the settings.json which is obtained from the Umbraco back-end. This is currently set 
to be the DStv business self service login page in the actual app. This then redirects the user 
to the Connect login page. 

The reason why the CIAM service is still uses is because the Connect auth requires a specific 
redirect url that needs to be whitelisted. A user can sign in from any page & the current 
functionality redirects the user back to the original page they were on. Changing the settings
in Umbraco to use Connect meant a user was being directed to the residential link up journey.
*/
class CiamService implements AuthService {
    _context: MenuContext;
    _signOutUrl: string;
    _signInUrl: string;
    _isBusiness: boolean;

    constructor(context: MenuContext) {
        this._context = context;

        const isBusiness = context.isBusinessSite;

        const settings = context.settings?.ciam;

        this._signInUrl = settings?.loginUrl;
        this._signOutUrl = settings?.logoutUrl;
        this._isBusiness = isBusiness;
    }

    signIn = () => {
        const signInUrl = this.getSignInUrl();

        gotoUrl(signInUrl);
    }

    signOut = () => {
        const signOutUrl = this.getSignOutUrl();

        gotoUrl(signOutUrl);
    }

    private _parseUrl(url: string) {
        if (url == null) {
            return "";
        }

        url = url
            .replace("{origin}", window.location.origin)
            .replace("{language}", this._languageCode);

        return url;
    }

    private get _languageCode() {
        const context = this._context;

        if (!context.culture) {
            return defaultLanguage;
        }

        return context.culture.culture;
    }

    getSignInUrl = () => {
        const currentUrl = getCurrentUrl(true);

        let signInUrl = this._signInUrl;

        signInUrl = this._parseUrl(signInUrl);
        signInUrl = addLanguageCode(signInUrl, this._languageCode);
        signInUrl = addRedirectUrl(signInUrl, currentUrl);

        return signInUrl;
    }

    getSignOutUrl = () => {
        const homePage = this._context.siteUrl;

        let signOutUrl = this._signOutUrl;
        signOutUrl = addLanguageCode(signOutUrl, this._languageCode);
        signOutUrl = addReturnUrl(signOutUrl, homePage);

        return signOutUrl;
    }
}

export default CiamService;